<template>
  <template
    v-if="props.item?.path.startsWith('http')"
  >
    <a
      :href="props.item?.path"
    >
      {{ props.item.name }}
    </a>
  </template>
  <template
    v-else
  >
    <RouterLink
      :to="props.item.children ? '' : props.item.path"
    >
      <slot/>
    </RouterLink>
  </template>
</template>
<script setup lang="ts">

export interface RouterLinkInterface {
  name: string;
  path: string;
  url?: string;
  targetBlank?: boolean;
  children?: Array<RouterLinkInterface>;
}

interface Props {
  item: RouterLinkInterface
}

const props = withDefaults(defineProps<Props>(), {});

</script>
